import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How does it actually work?",
    a: "Download the app, verify your email, and buy or redeem a plan right inside it. The app scans your PC and shows you exactly what it can change before touching anything — you apply what you want, on your own machine. No one remotes into your PC.",
  },
  {
    q: "Does it work on all PCs?",
    a: "Yes. It supports Windows 10 and 11 — desktops and laptops, AMD and Intel, NVIDIA and Radeon. Older rigs see the biggest gains.",
  },
  {
    q: "Is it safe?",
    a: "Every tweak is reversible. The app creates a Windows System Restore point and records the previous value of every setting before changing anything, and you can undo any single tweak or everything at once, any time.",
  },
  {
    q: "Do you need my password or remote access?",
    a: "No. The app runs entirely on your own PC — nobody at Flow Tweaks can see or control your device. It's not a remote-access tool of any kind.",
  },
  {
    q: "Will this get me banned?",
    a: "No. The app does not modify game files, inject code, or use cheats. Every tweak is at the OS or driver level — fully ToS compliant.",
  },
  {
    q: "Will it slow my PC down later?",
    a: "Opposite — fewer background services and bloatware mean it stays faster, longer. Every tweak is individually reversible if you ever want to turn one off.",
  },
];

export const FAQ = () => (
  <section id="faq" className="relative py-24 sm:py-32" data-testid="faq-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 0.6 }}
        className="mb-12"
      >
        <p className="text-orange-500 font-bold tracking-[0.3em] text-xs uppercase mb-4 slash">
          FAQ
        </p>
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]"
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          Got questions? <br />
          <span className="text-zinc-500">We've got answers.</span>
        </h2>
      </motion.div>

      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="glass !rounded-xl data-[state=open]:!border-orange-500/50 px-5 sm:px-6"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="text-left text-base sm:text-lg font-bold uppercase tracking-wide hover:text-orange-500 hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 text-sm sm:text-base leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

